import React, { useState } from "react";
import "./MaintenancePackage.css";
import image1 from "../../Assets/Image/pachageImg.PNG";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
export default function MaintenancePackage() {
  const navigate = useNavigate();

  async function searchForProduct() {
    const brand = document.getElementById("brand").value;
    const model = document.getElementById("model").value;
    const year = document.getElementById("year").value;
    const keywords = document.getElementById("keywords").value;
    const engineNumber = document.getElementById("engineNumber").value;
    const warrantyStatus = document.querySelector(
      'input[name="warrantyStatus"]:checked'
    )?.value;
    if (
      !brand &&
      !model &&
      !year &&
      !keywords &&
      !engineNumber &&
      !warrantyStatus
    ) {
      Swal.fire({
        icon: "warning",
        title: "No Input Provided",
        text: "Please enter at least one search criterion.",
        confirmButtonText: "OK",
      });
      return;
    }

    const params = new URLSearchParams();
    if (brand) params.append("brand", brand);
    if (model) params.append("model", model);
    if (year) params.append("year", year);
    if (keywords) params.append("keywords", keywords);
    if (engineNumber) params.append("carEngine", engineNumber);
    if (warrantyStatus) params.append("warranty", warrantyStatus);
    try {
      const response = await axios.get(
        `https://vehex-production.up.railway.app/product?${params.toString()}`
      );
      console.log(response.data);
      if (response.data?.products?.length > 0) {
        navigate("/products", {
          state: { searchResults: response.data.products },
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "No Product Found",
          text: "No Product Found",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error fetching data. Please try again.",
        confirmButtonText: "OK",
      });
    }
  }

  const [toggleState, settoggleState] = useState(1);

  const toggleTap = (index) => {
    settoggleState(index);
  };

  return (
    <>
      <div className="maintenance bg-black py-5">
        <div className="data container d-flex justify-content-between align-items-start">
          <div className="box d-flex justify-content-start align-items-start flex-column gap-2 container">
            <div className="text text-white mb-3">
              <h1 className="m-0 fw-400">Find Your Best</h1>
              <h2 className="second-color fw-bold m-0">Package Offer</h2>
            </div>
            <div className="imageCover">
              <img src={image1} alt="maintenace Package" className="w-100" />
            </div>
          </div>

          <div className="bg-white container p-0">
            <div className="biggg d-flex flex-column">
              <div className="bigHead bg-second-color d-flex mb-3">
                <div className="headd  w-50 d-flex position-relative align-items-center ">
                  <h1
                    className={
                      toggleState === 1
                        ? "text-black fs-5 fw-bold m-0 p-2 insert heading-active"
                        : "text-black fs-5 fw-bold m-0 p-2"
                    }
                    onClick={() => toggleTap(1)}
                  >
                    Search By Data{" "}
                  </h1>
                </div>

                <div className="headd w-50 d-flex position-relative  align-items-center">
                  <h1
                    className={
                      toggleState === 2
                        ? "text-black fs-5 fw-bold m-0 p-2  heading-active"
                        : "text-black fs-5 fw-bold m-0 p-2"
                    }
                    onClick={() => toggleTap(2)}
                  >
                    Search By VIN
                  </h1>
                </div>
              </div>
              <form className="px-3">
                <div
                  className={
                    toggleState === 1
                      ? "big d-flex justify-content-between flex-column content-active"
                      : "big d-flex justify-content-between flex-column"
                  }
                >
                  <label
                    htmlFor="carBrand"
                    className="main-color fw-500 fs-5 mb-2"
                  >
                    Car Brand
                  </label>
                  <input
                    type="text"
                    id="brand"
                    name="carBrand"
                    className="form-control mb-2"
                  />

                  <label
                    htmlFor="model"
                    className="main-color fw-500 fs-5 mb-2"
                  >
                    Model
                  </label>
                  <input
                    type="text"
                    id="model"
                    name="model"
                    className="form-control mb-2"
                  />

                  <label
                    htmlFor="year"
                    className="main-color fw-500 fs-5 mb-2"
                  >
                    Year
                  </label>
                  <input
                    type="number"
                    id="year"
                    name="year"
                    className="form-control mb-2"
                  />

                  <div className="dataa d-flex align-items-center justify-content-start gap-3">
                    <label
                      htmlFor="warranty"
                      className="main-color fs-5 fw-500"
                    >
                      Warranty:
                    </label>

                    <div className="d-flex align-items-center gap-3">
                      <div className="one">
                        <label
                          htmlFor="warranty"
                          className="main-color fw-500 fs-5"
                        >
                          True
                        </label>
                        <input
                          type="radio"
                          className="ms-2"
                          id="warranty"
                          name="warrantyStatus"
                          value="true"
                        />
                      </div>
                      <div className="two d-flex align-items-center">
                        <label
                          htmlFor="outOfWarranty"
                          className="main-color fw-500 fs-5"
                        >
                          False
                        </label>
                        <input
                          type="radio"
                          className="ms-2"
                          id="outOfWarranty"
                          name="warrantyStatus"
                          value="false"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form  className="px-3">
                <div
                  className={
                    toggleState === 2
                      ? "big d-flex flex-column content-active"
                      : "big d-flex flex-column "
                  }
                >
                  <label
                    htmlFor="engineNumber"
                    className="main-color fw-500 fs-5 mb-2"
                  >
                    Vehicle Number (VIN)
                  </label>
                  <input
                    type="text"
                    placeholder="for Example: 1HGBH41JXMN109186"
                    id="engineNumber"
                    name="engineNumber"
                    className="form-control mb-2"
                  />

                  <label
                    htmlFor="keywords"
                    className="main-color fw-500 fs-5 mb-2"
                  >
                    keywords
                  </label>
                  <input
                    type="text"
                    id="keywords"
                    name="keywords"
                    className="form-control mb-2"
                  />
                </div>
              </form>
              <button
                className="btn my-3 btn-danger w-50 m-auto d-block"
                onClick={() => searchForProduct()}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
